import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MembershipComponent from '../components/membership.component';
import { roles } from '../../../../../../redux/roles/action';
import { selectRolesListItems } from '../../../../../../redux/roles/selector';
import PageLoader from '../../../../../../components/PageLoader';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectMembershipsQueryItems } from '../../../../../../redux/memberships/selector';
import { memberships } from '../../../../../../redux/memberships/action';
import { tenantDomains } from '../../../../../../redux/tenant-domains/action';
import { selectTenantDomainsListItems } from '../../../../../../redux/tenant-domains/selector';


const ManagementMembership = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryData = useSelector(selectMembershipsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const rolesItems = useSelector(selectRolesListItems)
  const domainItems = useSelector(selectTenantDomainsListItems)
  const [
    selectedMembership,
    setSelectedMembership
  ] = useState<any>([])

  const fetchMembershipById = () => {
    dispatch(memberships.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/memberships/query`, entity: 'memberships', jsonData: {

        Records: [
          {


            "Id": parmas?.id



          }
        ]

      }
    })).then(() => {
      setIsQuery(true)

    })




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedMembership({ ...selectedMembership, [field]: event });
  }


  useEffect(
    () => {
      dispatch(roles.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/iam/roles/list`, entity: 'roles', jsonData: {

        }
      }))
        .then(() => {
          dispatch(tenantDomains.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/tenant-domains/list`, entity: 'tenantDomains', jsonData: {} }))
        })
        .then(() => {
          if (parmas?.id > 0) {
            fetchMembershipById()
            setIsLoading(false)
          } else {
            setIsLoading(false)
          }

        })


    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedMembership(queryData?.result?.items)
      }
    },
    [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      await dispatch(memberships.resetAction({ actionType: 'update' }))
      await dispatch(memberships.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/memberships`, entity: 'memberships', jsonData: {

          Records: [
            selectedMembership
          ]

        }
      })).then(() => {
        back()
      })

    } else {
      await dispatch(memberships.resetAction({ actionType: 'create' }))
      dispatch(memberships.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/membership-management/memberships`, entity: 'memberships', jsonData: {

          Records: [
            selectedMembership
          ]

        }
      })).then(() => {
        back()
      })
    }


  }

  const back = () => {
    navigate('/management/organization/membership-management/memberships')
  }

  return (
    <>

      {isLoading ? <PageLoader /> :
        <MembershipComponent
          domains={domainItems?.result?.items}
          handleInnerFormChange={handleInnerFormChange}
          selectedMembership={selectedMembership}
          back={back}
          handleFormSubmit={handleFormSubmit}
          roles={rolesItems?.result?.items}
        />
      }

    </>
  )

}

export default ManagementMembership;